// Single source of truth for product.product_type -- used by the type filter, the type chip
// in the products table, and SelectProductType.
// Tokens must match the CHECK constraint in schema-changes/007-product-type.sql.

export const PRODUCT_TYPES = [
	{token: 'primary', label: 'Primary', color: 'primary'},
	{token: 'supplemental', label: 'Supplemental', color: 'secondary'},
	{token: 'media', label: 'Media', color: 'info'},
]

export const getProductType = (token) => PRODUCT_TYPES.find(t => t.token === token)

/*
 * Only `primary` products count toward score metrics and render as stand-out cards on the
 * dashboard / progress report. `supplemental` and `media` are grouped and de-emphasised.
 *
 * Fails OPEN: a product with a missing or unrecognised product_type is treated as primary.
 * If the column or the vw_products view ever stops delivering the value, the effect is the
 * pre-068 behaviour (everything counted, everything prominent) rather than a user's material
 * disappearing from their dashboard and their score collapsing to zero.
 */
export const isPrimaryProduct = (product) => {
	const type = product?.product_type
	return !type || type === 'primary'
}

// { primary, supplemental } — `supplemental` holds both supplemental and media products.
// Input order is preserved within each group (prepkit products arrive sorted by sort_key).
export const splitProductsByType = (products) => {
	const list = products || []
	return {
		primary: list.filter(isPrimaryProduct),
		supplemental: list.filter(p => !isPrimaryProduct(p)),
	}
}

/*
 * [{type, products}] in PRODUCT_TYPES order (Primary, Supplemental, Media), with empty
 * groups dropped. Input order is preserved within each group.
 *
 * Fails OPEN the same way isPrimaryProduct does: a product with a missing or unrecognised
 * product_type lands in the Primary group rather than vanishing from the list.
 */
export const groupProductsByType = (products) => {
	const list = products || []
	const known = PRODUCT_TYPES.map(t => t.token)

	return PRODUCT_TYPES
		.map(type => ({
			type,
			products: list.filter(p => type.token === 'primary'
				? !known.includes(p?.product_type) || p.product_type === 'primary'
				: p?.product_type === type.token
			),
		}))
		.filter(g => g.products.length > 0)
}
